import { useTranslation } from 'react-i18next';
import { UAParser } from 'ua-parser-js';
import { BoundedContent, Box, Link } from '@vp/swan';
import LaunchMyBusinessTools from '../../components/LaunchMyBusinessTools/LaunchMyBusinessTools';
import LogoProductTiles from '../../components/LogoProductTiles/LogoProductTiles';
import { useTrackOnPageLoad } from '../../utils/analytics';
import { logoInspirationRootUrl } from '../../utils/urls';
import Faq from './components/Faq/Faq';
import Hero from './components/Hero/Hero';
import HowItWorks from './components/HowItWorks/HowItWorks';
import LogoGallery from './components/LogoGallery/LogoGallery';

const CORE_PRODUCT_ID = 'PRD-WRFGWR7PP';

const LogomakerGenAiPagePhase1 = () => {
    const { t } = useTranslation();
    const { browser, os, device } = UAParser();

    useTrackOnPageLoad('Product Viewed', {
        label: 'Product page view',
        core_product_id: CORE_PRODUCT_ID,
        variant: '',
    });

    useTrackOnPageLoad('Homepage Device Details', {
        label: 'Homepage:Device Details',
        core_product_id: CORE_PRODUCT_ID,
        browser,
        os,
        deviceType: device.type ?? 'desktop',
    });

    return (
        <>
            <Hero />
            <LogoGallery />
            <HowItWorks />
            <Faq />
            <BoundedContent overflow="hidden" bgc="warm-white">
                <Box marginY="between-sections">
                    <LogoProductTiles
                        title="Looking for a logo that's handcrafted from scratch?"
                        description={
                            <div>
                                Work with a professional designer to create a logo that's as unique
                                as your brand. Don't know where to start? Get inspired with our
                                range of{' '}
                                <Link href={logoInspirationRootUrl()} target="_blank">
                                    logo ideas
                                </Link>
                                .
                            </div>
                        }
                        showLogomaker={false}
                        trackingCategory="Design Services"
                    />
                </Box>
            </BoundedContent>
            <LaunchMyBusinessTools
                header={t('Vista Logos > Launch My Business Tools > Heading.value')}
                subheader={t(
                    'Vista Logos > Logomaker landing page > Launch My Business Tools > Description.value',
                )}
                businessTools={[
                    'businessNameGenerator',
                    'brandKit',
                    'wixWebsites',
                    'socialMediaTemplates',
                    'design',
                ]}
                trackingCategory="Design Services"
            />
        </>
    );
};

export default LogomakerGenAiPagePhase1;
